export default __webpack_public_path__ + "static/media/webDesktopScreen.2947beca.png";